import { h, setChildren } from "../core/dom.js";
import { api } from "../api.js";
import { achIcon } from "../lib/icons.js";
import { topbar, backLink } from "../components/common.js";
import { profile } from "../store.js";
import { milestoneCollection, nextMilestone } from "../lib/training.js";
import { spinner, errorState, toast } from "../components/ui.js";

export default function Achievements() {
  const root = h("div", { class: "screen" });
  load();

  async function load() {
    setChildren(root, backLink("Progress", "/history"), topbar("Achievements"), spinner());
    try {
      const data = await api.achievements();
      render(data);
    } catch (e) {
      setChildren(root, topbar("Achievements"), errorState(e.message, load));
    }
  }

  function render(data) {
    const collection=milestoneCollection(profile());
    const content=h("div");
    const select=h("select",{id:"milestone-collection",class:"select",onChange:async()=>{
      try { profile(await api.updateMe({milestone_focus:select.value})); render(data); toast("Milestone collection saved","success"); }
      catch(e) { toast(e.message,"error"); }
    }},...[["auto","Match my training goal"],["consistency","Consistency"],["strength","Strength"],["endurance","Endurance"],["exploration","Exploration"]].map(([value,label])=>h("option",{value,selected:value===(profile()?.milestone_focus || "auto")},label)));
    const selected=data.badges.filter(b=>b.collection===collection);
    const next=nextMilestone(data.badges,collection);
    const earned=selected.filter(b=>b.earned);
    setChildren(root,backLink("Progress","/history"),topbar("Achievements",{sub:"Personal milestones, at your pace"}),
      h("div",{class:"field"},h("label",{for:select.id},"My milestone collection"),select),
      h("p",{class:"dim"},"Choose what matters to you. Rest days and paused weeks don't erase earned milestones. More volume or longer workouts aren't requirements for progress."),
      next?h("section",{class:"next-milestone"},h("span",{class:"eyebrow"},"YOUR NEXT MILESTONE"),badge(next)):h("p",{class:"empty-note"},"You've earned every milestone in this collection. Keep training toward the goals you care about."),
      h("h2",{class:"section-title"},"Earned in this collection"),
      earned.length?h("div",{class:"badge-grid"},...earned.map(badge)):h("p",{class:"dim"},"Your first milestone here is ahead of you. Each logged session adds to your history."),
      h("details",{class:"home-details"},h("summary",null,"Explore milestones & earned archive"),
        ...[["consistency","Consistency"],["strength","Strength"],["endurance","Endurance"],["exploration","Exploration"],["archive","Earlier volume & time milestones"]].map(([key,label])=>h("section",null,h("h2",{class:"section-title"},label),
          key==="archive"?h("p",{class:"dim"},"Earlier achievements remain yours. These totals are historical records, not targets to chase."):null,
          h("div",{class:"badge-grid"},...data.badges.filter(b=>b.collection===key && (key!=="archive" || b.earned)).map(badge))))));
  }

  function badge(b) {
    return h(
      "div",
      { class: ["ach", b.earned && "ach-earned"] },
      h("div", { class: "ach-icon" }, achIcon(b.icon, { size: 30 })),
      h("div", { class: "ach-title" }, b.title),
      h("div", { class: "ach-desc" }, b.description),
      !b.earned
        ? h("div", { class: "ach-progress" },
            h("div", { class: "progress",role:"progressbar","aria-label":b.title,"aria-valuenow":b.value,"aria-valuemin":0,"aria-valuemax":b.target }, h("i", { style: { width: `${b.progress * 100}%` } })),
            h("div", { class: "dim", style: { fontSize: "0.7rem", marginTop: "4px" } }, `${Math.round(b.value).toLocaleString()} / ${b.target.toLocaleString()}`)
          )
        : h("div", { class: "ach-check" }, "✓ Unlocked")
    );
  }

  return root;
}
